/* ALQUIMIA CHARMS - Escalera de incentivos viva en el cart drawer.

   Mantiene sincronizados, sin recargar la pagina:
     1. Charm sorpresa de bienvenida  (REQUIERE REGISTRO, desde $870, <6 charms)
     2. Envio gratis en Mexico        (desde $1,160)
     3. Promocion 4+2                 (la pinta alquimia-promo-message.js)

   SOBRE EL REGALO Y EL REGISTRO
   -----------------------------
   Este archivo NO otorga el regalo: no agrega ninguna linea al carrito ni aplica
   ningun descuento. Solo decide QUE MENSAJE se muestra.

   La autorizacion real vive en el servidor:
     - registro   = Shopify Customer con tag "popup-registro" (creado por el
                    formulario nativo del popup, deduplicado por email)
     - redencion  = tag "regalo-usado" que Shopify Flow escribe DESPUES de que
                    un pedido queda pagado
   Por eso borrar cookies, usar incognito, cambiar de telefono o volver a
   registrarse con el mismo correo no consigue un segundo regalo: lo unico que
   cambia es el mensaje que ve el visitante, no lo que se empaca.

   Reglas de diseno de red:
   - NO MutationObserver y NO inyeccion de nodos: cero riesgo de bucles.
   - UNA sola peticion a /cart.js por cambio de carrito (limite de tasa 429). */
(function () {
  var GIFT_MIN = 87000;    // $870 MXN - condicion comercial del charm sorpresa
  var FREE_SHIP = 116000;  // $1,160 MXN - debe coincidir con Envios > Domestic
  var PROMO_BLOCK = 6;     // charms necesarios para que el 4+2 se active

  var enVuelo = false;
  var timer = null;
  var backoffHasta = 0;
  var ultimoCarrito = null;

  window.__alqCartLiveActive = true;

  function money(c) {
    try { return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }

  function estaRegistrado(el) {
    if (el && el.getAttribute('data-logged') === 'true') return true;   // sesion iniciada
    if (typeof window.alqGiftRegistered === 'function') {
      try { return window.alqGiftRegistered() === true; } catch (e) {}
    }
    try { return localStorage.getItem('alq_gift_registered') === '1'; } catch (e) { return false; }
  }

  function contarCharms(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if ((it.product_type || '') === 'Charm') n += it.quantity;
    });
    return n;
  }

  function pintarRegalo(cart) {
    var nodos = document.querySelectorAll('[data-alquimia-gift]');
    var charms = contarCharms(cart);
    var sub = cart.total_price;
    for (var i = 0; i < nodos.length; i++) {
      var el = nodos[i];

      // Con 6 o mas charms manda el 4+2: el regalo de bienvenida no se acumula.
      if (!cart.item_count || charms >= PROMO_BLOCK) {
        el.setAttribute('hidden', '');
        continue;
      }
      el.removeAttribute('hidden');

      var html;
      if (!estaRegistrado(el)) {
        // --- VISITANTE NO REGISTRADO: invitacion, nunca desbloqueo ---
        el.className = 'alquimia-gift alquimia-gift--cta';
        html = '<p class="alquimia-gift__title">🎁 ¿Quieres un charm sorpresa?</p>' +
               '<p class="alquimia-gift__line">Regístrate y desbloquea tu regalo de bienvenida.</p>' +
               '<button type="button" class="alquimia-gift__cta" data-alquimia-gift-cta>DESBLOQUEAR MI REGALO</button>';
      } else if (sub >= GIFT_MIN) {
        el.className = 'alquimia-gift alquimia-gift--unlocked';
        html = '<p class="alquimia-gift__title">🎁 Tu charm sorpresa va incluido</p>' +
               '<p class="alquimia-gift__line">Lo elegimos nosotros y lo metemos en tu paquete. Válido una vez por cliente.</p>';
      } else {
        el.className = 'alquimia-gift';
        var falta = GIFT_MIN - sub;
        var pct = Math.min(100, (sub * 100) / GIFT_MIN);
        html = '<p class="alquimia-gift__title">Te faltan <strong>' + money(falta) + '</strong> para tu charm sorpresa 🎁</p>' +
               '<div class="alquimia-gift__track"><div class="alquimia-gift__fill" style="width:' + pct + '%"></div></div>';
      }
      if (el.innerHTML !== html) el.innerHTML = html;
    }
  }

  function pintarEnvio(cart) {
    var barras = document.querySelectorAll('[data-alquimia-shipping-bar]');
    for (var i = 0; i < barras.length; i++) {
      var bar = barras[i];
      if (!cart.item_count) { bar.setAttribute('hidden', ''); continue; }
      bar.removeAttribute('hidden');
      var cur = cart.total_price;
      var rem = FREE_SHIP - cur;
      var pct = Math.min(100, (cur * 100) / FREE_SHIP);
      var msg = bar.querySelector('.alquimia-shipping-bar__message');
      var fill = bar.querySelector('.alquimia-shipping-bar__fill');
      var track = bar.querySelector('.alquimia-shipping-bar__track');
      var nuevo = rem <= 0
        ? 'Ya desbloqueaste <strong>envío gratis en México</strong> 🚚✨'
        : 'Te faltan <strong>' + money(rem) + '</strong> para desbloquear <strong>envío gratis en México</strong> 🚚';
      if (rem <= 0) bar.classList.add('alquimia-shipping-bar--unlocked');
      else bar.classList.remove('alquimia-shipping-bar--unlocked');
      if (msg && msg.innerHTML !== nuevo) msg.innerHTML = nuevo;
      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', Math.round(pct));
    }
  }

  function pintar(cart) {
    ultimoCarrito = cart;
    pintarRegalo(cart);
    pintarEnvio(cart);
    if (window.alquimiaPromoPaint) {
      try { window.alquimiaPromoPaint(cart); } catch (e) {}
    }
  }

  function sync() {
    if (enVuelo) return;
    if (Date.now() < backoffHasta) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!document.querySelector('[data-alquimia-shipping-bar]')) return;
      enVuelo = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) {
          if (r.status === 429) { backoffHasta = Date.now() + 10000; return null; }
          return r.json();
        })
        .then(function (cart) { if (cart) pintar(cart); })
        .catch(function () { backoffHasta = Date.now() + 5000; })
        .then(function () { enVuelo = false; });
    }, 1200);
  }

  ['cart:updated', 'cart:refresh', 'cart:change', 'on:cart:change', 'ajaxCart.afterCartLoad', 'cart:build']
    .forEach(function (ev) { document.addEventListener(ev, sync); });

  // El popup avisa al completarse el registro: repintamos sin pedir red de nuevo.
  document.addEventListener('alq:registered', function () {
    if (ultimoCarrito) pintarRegalo(ultimoCarrito); else sync();
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var cta = e.target.closest('[data-alquimia-gift-cta]');
    if (cta) {
      e.preventDefault();
      if (typeof window.alqOpenWelcomePopup === 'function') window.alqOpenWelcomePopup();
      else window.location.href = '/account/register';
      return;
    }

    var hit = e.target.closest('.m-add-to-cart, [name="add"], [data-alquimia-rec-add], [data-cart-remove], .m-cart-item__remove, .m-quantity__button');
    if (!hit) return;
    sync();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
